import React from 'react'
import { Link } from 'react-router-dom'

const CreateGame = () => {
    return (
        <>
            <div className="page-wrapper">
                <div className="page-content">
                    <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
                        <div className="breadcrumb-title pe-3">Games Management</div>
                        <div className="ps-3">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb mb-0 p-0">
                                    <li className="breadcrumb-item"><Link to="/"><i className="bx bx-home-alt" /></Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">Create Game</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                    <hr />
                    <div className="detail_top_pgg">
                        <Link to="/game-management"><i className="bx bx-arrow-back" /><span>Back</span></Link>
                    </div>
                    <div className="card personal_d mt-4">
                        <div className="card-body">
                            <h2>Select Teams</h2>
                            <div className="row">
                                <div className="col-md-6">
                                    <label className="form-label">Home Team</label>
                                    <select className="form-select" name="hometeam">
                                        <option selected>Select Team</option>
                                        <option value="Team A">Team A</option>
                                        <option value="Team B">Team B</option>
                                        <option value="Team C">Team C</option>
                                    </select>
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label">Away Team</label>
                                    <select className="form-select" name="awayteam">
                                        <option selected>Select Team</option>
                                        <option value="Team D">Team D</option>
                                        <option value="Team E">Team E</option>
                                        <option value="Team F">Team F</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card personal_d mt-4">
                        <div className="card-body">
                            <h2>Add Venue</h2>
                            <div className="row">
                                <div className="col-md-6">
                                    <label className="form-label">Venue Name</label>
                                    <input type="text" name="venue-name" className="form-control" defaultValue="Stadium A" />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label">Venue Address</label>
                                    <input type="text" name="venue-address" className="form-control" defaultValue="USA" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card personal_d mt-4">
                        <div className="card-body">
                            <h2>Schedule Game</h2>
                            <div className="row">
                                <div className="col-md-4">
                                    <label className="form-label">Age Group</label>
                                    <select className="form-select" name="agegroup">
                                        <option value="U-11">U-11</option>
                                        <option value="U-12">U-12</option>
                                        <option value="U-13">U-13</option>
                                        <option value="U-14">U-14</option>
                                        <option value="U-15">U-15</option>
                                        <option value="U-16">U-16</option>
                                        <option value="U-17" selected>U-17</option>
                                    </select>
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label">Game Date</label>
                                    <input type="date" name="date" className="form-control" />
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label">Game Duration</label>
                                    <select className="form-select" name="duration">
                                        <option value="40 Minutes">40 Minutes</option>
                                        <option value="60 Minutes">60 Minutes</option>
                                        <option value="80 Minutes">80 Minutes</option>
                                        <option value="90 Minutes">90 Minutes</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card personal_d mt-4">
                        <div className="card-body">
                            <h2>Offer Referees</h2>
                            <div className="row align-items-end">
                                <div className="col-md-4">
                                    <label>Offer Fee</label>
                                    <input type="text" className="form-control" defaultValue="$500" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card personal_d mt-4">
                        <div className="card-body">
                            <h2>Add Payment Method</h2>
                            <div className="row align-items-end">
                                <div className="col-md-4">
                                    <label className="form-label">Card Number</label>
                                    <input type="number" className="form-control" />
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label">Expiry</label>
                                    <input type="number" className="form-control" />
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label">CVV</label>
                                    <input type="number" className="form-control" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="text-end mb-3">
                        <button type="submit" className="btn btn-primary">Submit Game</button>
                    </div>
                </div>
            </div>

        </>
    )
}

export default CreateGame